import React, {Component} from 'react';
import {Grid, Row, Col, Tabs, Tab} from "react-bootstrap";
import TopBreadcumb from "../../../componentsTopsa/breadcrumbs/TopBreadcumb";
import SubHeader from "../../../shared/sidebar/SubHeader";
import SidebarComponent from "../../../shared/sidebar/SidebarComponent";
import Links from "../../../utilities/linksConfig/Links";
import ReactNotify from 'react-notify';
import StronaKlientaTabJednorazowe from "./components/StronaKlientaTabJednorazowe";
import StronaKlientaTabMiesieczne from "./components/StronaKlientaTabMiesieczne";
import KlienciService from "../KlienciService";
import StronaKlientaDane from "./components/StronaKlientaDane";
import {TopAlertUwaga} from "../../../componentsTopsa/alerty/TopAlerts";
import KlienciBiletyService from "../KlienciBiletyService";
import KlienciForm from "../klienci/components/KlienciForm";
import TopIf from "../../../componentsTopsa/if/TopIf";


export default class StronaKlientaContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: 1,
            klient: null,
            czyByloSzukanie: false,
            jednorazowe: [],
            miesiecznezkart: [],

            czyLadowanie:false,

            page:1,
            size:10,
            pageable:{
                first: false,
                last: false,
                page: 0,
                size: 0,
                totalElements: 0,
                totalPages: 0,
            }
        };
        this.changeActiveTab = this.changeActiveTab.bind(this)
        this.onClickZapisz = this.onClickZapisz.bind(this)
    }

    componentDidMount() {
        if (this.props.history.location.pathname === "/zarzadzanie-klientami/klient/1") {
            this.props.history.push('/zarzadzanie-klientami/klienci')
        }
        else
            this.pobierzKlienta(this.props.match.params.idKl)
    }

    pobierzKlienta(id) {
        this.setState({czyByloSzukanie: false})
        KlienciService.getKlient(id).then(function (response) {
            let objzdj = null

            if (Boolean(response.data)) {
                objzdj = response.data

                let zdjecieProfilowe = null
                let zdjeciaSkany = []
                let dokumentySkany = []
                if (response.data.pliki.length > 0) {
                    zdjecieProfilowe = response.data.pliki.find(p => p.dokumentTyp == 'KLIENT_ZDJECIE' && p.typ.indexOf('image')>-1);
                    zdjeciaSkany = response.data.pliki.filter(p => p.dokumentTyp == 'KLIENT_DOK_SKAN' && p.typ.indexOf('image')>-1);
                    dokumentySkany = response.data.pliki.filter(p => p.typ.indexOf('image')===-1);
                }


                objzdj = Object.assign(objzdj, {zdjecieProfilowe: zdjecieProfilowe})
                objzdj = Object.assign(objzdj, {zdjeciaSkany: zdjeciaSkany})
                objzdj = Object.assign(objzdj, {dokumentySkany: dokumentySkany})



            }
            this.setState({klient: objzdj, czyByloSzukanie: true})
            if (Boolean(response.data)) {
                this.pobierzBiletyJednorazowe(response.data.idKl)
                this.pobierzKarty(response.data.idKl)
            }
        }.bind(this))
    }

    renderContent() {
        if (this.state.activeTab === 1) {
            return <StronaKlientaTabJednorazowe history={this.props.history}
                                                jednorazowe={this.state.jednorazowe}
                                                klient={this.state.klient}

                                                page={this.state.page}
                                                size={this.state.size}
                                                pageable={this.state.pageable}


                                                handleOnPageChange={(page)=>{
                                                    this.setState({page:page})
                                                    this.pobierzBiletyJednorazowe(this.state.klient.idKl, page, this.state.size)
                                                }}
                                                handleOnSizeChange={(size)=>{
                                                    this.setState({size:size})
                                                    this.pobierzBiletyJednorazowe(this.state.klient.idKl, 1, size)
                                                }}

                                                handleOdswiezJednorazowe={() => {
                                                    this.pobierzBiletyJednorazowe(this.state.klient.idKl)
                                                }}
            />
        }
        else if (this.state.activeTab === 2) {
            return <StronaKlientaTabMiesieczne history={this.props.history}
                                               klient={this.state.klient}
                                               miesieczne={this.state.miesiecznezkart}/>
        }
    }

    changeActiveTab(eventKey) {
        this.setState({activeTab: eventKey})
    }

    pobierzBiletyJednorazowe(idKl, page = this.state.page, size = this.state.size) {

        this.setState({
            czyLadowanie:true
        })

        KlienciBiletyService.pobierzBiletyJednorazoweDanegoKlienta(idKl,page-1,size).then(function (response) {

            this.setState({
                czyLadowanie:false
            })

            console.log(response)
            let bilety = Array.from(response.data.content, item => {
                let kod = item.idBi
                if (Boolean(item.idBiPow)) {
                    kod += " " + item.idBiPow
                } else {
                    let zero = ''
                    for (let i = 0; i < item.idBi.length; i++) {
                        zero += '0'
                    }
                    kod += ' ' + zero
                }
                let platnosci = ''
                if (Boolean(item.platnosciTransakcja)) platnosci += item.platnosciTransakcja + ' '
                if (Boolean(item.platnoscTpay)) platnosci += item.platnoscTpay
                return {
                    ...item,
                    kodInfo: kod,
                    klientInfo: item.klient + ' ' + item.klientTelefon + ' ' + item.klientEmail + ' ' + item.nazKl,
                    infoPlatnosci: platnosci,
                    infoOdcinek: item.nazTr + ' ' + item.nazMiOd + ' ' + item.nazMiDo
                }
            })

            this.setState({
                jednorazowe: bilety,
                pageable: {
                    first: response.data.first,
                    last: response.data.last,
                    page: response.data.number,
                    size: response.data.size,
                    totalElements: response.data.totalElements,
                    totalPages: response.data.totalPages,
                },
            })
        }.bind(this)).catch(function (error) {

            this.setState({
                czyLadowanie:false
            })

        }.bind(this))
    }

    pobierzKarty(idKl) {
        KlienciBiletyService.pobierzKartyDanegoKlienta(idKl).then(function (response) {
            if (response.data) {
                if (response.data.length > 0) {
                    this.pobierzBiletyMiesieczneNaKarcie(response.data)
                }
            }
        }.bind(this))
    }

    pobierzBiletyMiesieczneNaKarcie(array) {
        let arr = []
        for (let i = 0; i < array.length; i++) {
            KlienciBiletyService.pobierzBiletyMiesieczneNaKarcie(array[i].idKa).then(function (res) {
                let bm = Array.from(res.data, item => {
                    let platnosci = ''
                    if (Boolean(item.platnosciTransakcja)) platnosci += item.platnosciTransakcja + ' '
                    if (Boolean(item.platnoscTpay)) platnosci += item.platnoscTpay
                    return {
                        ...item,
                        infoPlatnosci: platnosci,
                    }
                })

                arr.push(Object.assign(array[i], {biletymiesieczne: this.formatujBiletyMiesieczneNaKarcie(bm)}))
            }.bind(this))
        }
        this.setState({miesiecznezkart: arr})
    }

    sprawdzCzyRokIMiesiacTenSam(obj1, obj2) {
        return (obj1.rok === obj2.rok && obj1.miesiac === obj2.miesiac)
    }

    formatujBiletyMiesieczneNaKarcie(array) {
        if (array.length === 0) return []

        else if (array.length === 1 || array[0].kierunek === 1) {
            return array
        }
        else {
            let newarr = []
            for (let i = 0; i < array.length; i++) {

                if (i === 0) {
                    // pierwszy
                    if (this.sprawdzCzyRokIMiesiacTenSam(array[0], array[1])) {
                        // jest dupliakcja

                        let obj = array[0]
                        obj = Object.assign(obj, {dwiestrony: true, calacena: (parseFloat(array[0].cena) + parseFloat(array[1].cena)).toFixed(2)})
                        newarr.push(obj);
                        i++
                    }
                    else {
                        newarr.push(array[0], array[1])
                    }
                }
                else if (i === array.length - 1) {
                    // ostatni
                    if (this.sprawdzCzyRokIMiesiacTenSam(array[i - 1], array[i])) {
                        // jest duplikacja
                        let obj = array[i - 1]
                        obj = Object.assign(obj, {dwiestrony: true, calacena: parseFloat(array[i - 1].cena) + parseFloat(array[i].cena)})
                        newarr.push(obj);
                        i++
                    }
                    else {
                        newarr.push(array[i - 1], array[i])
                    }

                }
                else {
                    // środkowe
                    if (this.sprawdzCzyRokIMiesiacTenSam(array[i], array[i + 1])) {
                        // jest duplikacja
                        let obj = array[i]
                        obj = Object.assign(obj, {dwiestrony: true, calacena: parseFloat(array[i].cena) + parseFloat(array[i + 1].cena)})
                        newarr.push(obj);
                        i++
                    }
                    else {
                        newarr.push(array[i], array[i + 1])
                    }
                }
            }

            return (newarr)
        }

    }


    onClickZapisz(obj) {
        KlienciService.editKlient(obj.idKl, obj).then(function (response) {
            this.setState({klientDoEdycji: null})
            this.pobierzKlienta(obj.idKl)
        }.bind(this))
    }

    render() {

        return (
            <SidebarComponent links={Links.getKonfiguracjaLinks} currentLink={this.props.match.path} history={this.props.history}
                              collapsedLinks={this.props.collapsedLinks}
                              handleClickToogleSidebar={(module) => this.props.handleClickToogleSidebar(module)}>
                <Grid fluid={true} id={'KlienciContainer'}>
                    <ReactNotify ref='notificator'/>
                    <Row>
                        <Col sm={12}>
                            <div id="subheader">
                                <TopBreadcumb links={[{
                                    addressUrl: '/zarzadzanie-klientami',
                                    text: 'Zarządzanie klientami'
                                }, {addressUrl: '/zarzadzanie-klientami/klienci', text: 'Klienci'}, {
                                    addressUrl: '/zarzadzanie-klientami/klient',
                                    text: 'Strona klienta'
                                }]}/>
                                <SubHeader currentLink={this.props.match.path} obecnyKalendarz={this.props.obecnyKalendarz}
                                           history={this.props.history}/>
                            </div>
                        </Col>
                    </Row>
                    {
                        Boolean(this.state.klient) ?
                            <Row>

                                {
                                    Boolean(this.state.klientDoEdycji) ?
                                        <Col xs={12} lg={12} style={{marginBottom: '15px'}}>
                                            <KlienciForm edytowany={this.state.klientDoEdycji}
                                                         handleClickZapisz={this.onClickZapisz}
                                                         handleClickAnuluj={() => this.setState({klientDoEdycji: null})}
                                                         edycjaNaStronieKlienta={true}
                                            />
                                        </Col>
                                        :
                                        <Col xs={12} lg={7}>
                                            <StronaKlientaDane klient={this.state.klient}
                                                               history={this.props.history}
                                                               handleClickEdytuj={() => this.setState({klientDoEdycji: this.state.klient})}/>
                                        </Col>
                                }
                                <Col sm={12}>
                                    <Tabs defaultActiveKey={1} id="ebok-tab" onSelect={this.changeActiveTab}>
                                        <Tab eventKey={1} title="Bilety jednorazowe">
                                        </Tab>
                                        <Tab eventKey={2} title="Karty i bilety miesięczne">
                                        </Tab>
                                    </Tabs>
                                </Col>
                                <Col sm={12}>
                                    <div style={{marginTop: '15px'}}>
                                        {this.renderContent()}
                                    </div>
                                </Col>
                            </Row>
                            :
                            Boolean(this.state.czyByloSzukanie) ?
                                <TopAlertUwaga text={'Nie można odczytać danych klienta'}/>
                                :
                                <div id={'smallLoader'}>
                                    <i className={'fa fa-circle-o-notch fa-spin'}></i>
                                    <div>Trwa ładowanie danych...</div>
                                </div>
                    }

                    <TopIf isTrue={this.state.czyLadowanie}>
                        <div id={'GenerowanieContainer'}>
                            <h1>
                                <i className={'fa fa-spinner fa-spin'}></i>
                                <div>
                                    Trwa ładowanie danych...
                                </div>
                                <h6>
                                    Proces ten może potrwać dłuższą chwilę
                                </h6>
                            </h1>
                        </div>
                    </TopIf>
                </Grid>
            </SidebarComponent>
        );
    }
}





// WEBPACK FOOTER //
// ./src/modules/klienciConfig/stronaKlienta/StronaKlientaContainer.js